import { AdScriptBanner } from '@/components/AdScriptBanner';

export const AdsterraMediumRect = () => {
  // 300x250 medium rectangle ad
  return (
    <div className="overflow-x-auto">
      <div className="flex justify-center">
        <AdScriptBanner
          atKey="60292f74602730a1fb61df35d22a703f"
          scriptSrc="https://yesterdaydefinitelycorrespondence.com/60292f74602730a1fb61df35d22a703f/invoke.js"
          width={300}
          height={250}
        />
      </div>
    </div>
  );
};
